module.exports = __webpack_public_path__ + "static/media/1-1.3ba500d1.jpg";